// Export an array of topics for VA 1st Grade Science
const va3rdSocialStudiesQuizContent = [
 
  // Ancient China - Multiple Choice
  {
    "slug": "ancientchina",
    "title": "Ancient China",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Which continent was Ancient China a part of according to the song?",
        "questionImage": "",
        "answers": [
          { "text": "Asia", "correct": true, "image": "" },
          { "text": "Africa", "correct": false, "image": "" },
          { "text": "Europe", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What kind of written language did people in Ancient China use?",
        "questionImage": "",
        "answers": [
          { "text": "Symbols", "correct": true, "image": "" },
          { "text": "Alphabet", "correct": false, "image": "" },
          { "text": "Runes", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which river did Ancient China use for irrigation and farming?",
        "questionImage": "",
        "answers": [
          { "text": "Huang He River", "correct": true, "image": "" },
          { "text": "Nile River", "correct": false, "image": "" },
          { "text": "Tigris River", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which invention from Ancient China helped people find directions?",
        "questionImage": "",
        "answers": [
          { "text": "Compass", "correct": true, "image": "" },
          { "text": "Clock", "correct": false, "image": "" },
          { "text": "Abacus", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which large structure did the people of Ancient China build to protect their land?",
        "questionImage": "",
        "answers": [
          { "text": "Great Wall", "correct": true, "image": "" },
          { "text": "Colosseum", "correct": false, "image": "" },
          { "text": "Pyramids", "correct": false, "image": "" }
        ]
      }
    ]
  },
  

  // Ancient Egypt - Multiple Choice
  {
    "slug": "ancientegypt",
    "title": "Ancient Egypt",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. On which continent was Ancient Egypt located according to the song?",
        "questionImage": "",
        "answers": [
          { "text": "Africa", "correct": true, "image": "" },
          { "text": "Asia", "correct": false, "image": "" },
          { "text": "Europe", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which river provided water for farming in Ancient Egypt?",
        "questionImage": "",
        "answers": [
          { "text": "Nile River", "correct": true, "image": "" },
          { "text": "Tigris River", "correct": false, "image": "" },
          { "text": "Euphrates River", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How is the climate of Ancient Egypt described in the song?",
        "questionImage": "",
        "answers": [
          { "text": "Hot and dry", "correct": true, "image": "" },
          { "text": "Cold", "correct": false, "image": "" },
          { "text": "Rainy", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What kind of writing did Ancient Egyptians use according to the song?",
        "questionImage": "",
        "answers": [
          { "text": "Hieroglyphics", "correct": true, "image": "" },
          { "text": "Cuneiform", "correct": false, "image": "" },
          { "text": "Alphabet", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which large structures are Ancient Egyptians famous for building?",
        "questionImage": "",
        "answers": [
          { "text": "Pyramids", "correct": true, "image": "" },
          { "text": "Great Wall", "correct": false, "image": "" },
          { "text": "Parthenon", "correct": false, "image": "" }
        ]
      }
    ]
  },
  

  // They Built - Drag and Drop
  {
    "slug": "theybuilt",
    "title": "They Built",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the directions, then drag each name to what it built. Match each civilization to its structure.",
        "options": [
          { "id": "greece1", "text": "Ancient Greece", "image": "", "targetText": "Parthenon", "targetImage": "" },
          { "id": "rome1", "text": "Ancient Rome", "image": "", "targetText": "Coliseum", "targetImage": "" },
          { "id": "china1", "text": "Ancient China", "image": "", "targetText": "Great Wall", "targetImage": "" }
        ]
      },
      {
        "question": "Read the directions, then drag each name to what it used for water. Match each civilization to how it got or used water.",
        "options": [
          { "id": "rome2", "text": "Ancient Rome", "image": "", "targetText": "Aqueducts", "targetImage": "" },
          { "id": "egypt1", "text": "Ancient Egypt", "image": "", "targetText": "Nile River", "targetImage": "" },
          { "id": "china2", "text": "Ancient China", "image": "", "targetText": "Huang He River", "targetImage": "" }
        ]
      },
      {
        "question": "Read the directions, then drag each name to what the people built for learning or gathering.",
        "options": [
          { "id": "greece2", "text": "Ancient Greece", "image": "", "targetText": "Theaters", "targetImage": "" },
          { "id": "rome3", "text": "Ancient Rome", "image": "", "targetText": "Forums", "targetImage": "" },
          { "id": "mali1", "text": "Mali Empire", "image": "", "targetText": "Timbuktu schools", "targetImage": "" }
        ]
      },
      {
        "question": "Read the directions, then drag each name to what they traded or used for trade.",
        "options": [
          { "id": "mali2", "text": "Mali Empire", "image": "", "targetText": "Gold and salt", "targetImage": "" },
          { "id": "rome4", "text": "Ancient Rome", "image": "", "targetText": "Coins", "targetImage": "" },
          { "id": "greece3", "text": "Ancient Greece", "image": "", "targetText": "Olive oil", "targetImage": "" }
        ]
      },
      {
        "question": "Read the directions, then drag each name to what it is known for building.",
        "options": [
          { "id": "china3", "text": "Ancient China", "image": "", "targetText": "Compass", "targetImage": "" },
          { "id": "egypt2", "text": "Ancient Egypt", "image": "", "targetText": "Pyramids", "targetImage": "" },
          { "id": "rome5", "text": "Ancient Rome", "image": "", "targetText": "Roads", "targetImage": "" }
        ]
      }
    ]
  },
  


  // Ancient Greece - Multiple Choice
  {
    "slug": "ancientgreece",
    "title": "Ancient Greece",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What kind of clothing did people in Ancient Greece wear according to the song?",
        "questionImage": "",
        "answers": [
          { "text": "Chiton", "correct": true, "image": "" },
          { "text": "Toga", "correct": false, "image": "" },
          { "text": "Kimono", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which city in Ancient Greece was known for education and learning?",
        "questionImage": "",
        "answers": [
          { "text": "Athens", "correct": true, "image": "" },
          { "text": "Sparta", "correct": false, "image": "" },
          { "text": "Troy", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What did the Greeks call their marketplaces where they traded goods?",
        "questionImage": "",
        "answers": [
          { "text": "Agoras", "correct": true, "image": "" },
          { "text": "Bazaars", "correct": false, "image": "" },
          { "text": "Fora", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What type of government is Ancient Greece called the birthplace of in the song?",
        "questionImage": "",
        "answers": [
          { "text": "Democracy", "correct": true, "image": "" },
          { "text": "Monarchy", "correct": false, "image": "" },
          { "text": "Empire", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which famous temple with rows of columns was built in Athens?",
        "questionImage": "",
        "answers": [
          { "text": "Parthenon", "correct": true, "image": "" },
          { "text": "Pantheon", "correct": false, "image": "" },
          { "text": "Colosseum", "correct": false, "image": "" }
        ]
      }
    ]
  },
  

  // Ancient Rome - Multiple Choice
  {
    "slug": "ancientrome",
    "title": "Ancient Rome",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. In which modern country is the city of Rome located today?",
        "questionImage": "",
        "answers": [
          { "text": "Italy", "correct": true, "image": "" },
          { "text": "France", "correct": false, "image": "" },
          { "text": "Greece", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What word describes Ancient Rome’s large area of control across continents?",
        "questionImage": "",
        "answers": [
          { "text": "Empire", "correct": true, "image": "" },
          { "text": "Village", "correct": false, "image": "" },
          { "text": "Kingdom", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which major sea was Ancient Rome located next to as the song explains?",
        "questionImage": "",
        "answers": [
          { "text": "Mediterranean Sea", "correct": true, "image": "" },
          { "text": "Black Sea", "correct": false, "image": "" },
          { "text": "Red Sea", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which structure did Romans build to carry water to their cities?",
        "questionImage": "",
        "answers": [
          { "text": "Aqueducts", "correct": true, "image": "" },
          { "text": "Walls", "correct": false, "image": "" },
          { "text": "Lighthouses", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What form of government did Romans use where people voted for representatives?",
        "questionImage": "",
        "answers": [
          { "text": "Republic", "correct": true, "image": "" },
          { "text": "Monarchy", "correct": false, "image": "" },
          { "text": "Dictatorship", "correct": false, "image": "" }
        ]
      }
    ]
  },
  

  // Mali - Drag and Drop
  // Mali - Drag and Drop
  {
    "slug": "mali",
    "title": "Mali",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Grab or click an item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match Mali facts to the right idea.",
        "options": [
          { "id": "mali1", "text": "Mali", "image": "", "targetText": "Trade center", "targetImage": "" },
          { "id": "kings1", "text": "Kings", "image": "", "targetText": "Wealthy", "targetImage": "" },
          { "id": "timbuktu1", "text": "Timbuktu", "image": "", "targetText": "Important city", "targetImage": "" }
        ]
      },
      {
        "question": "Grab or click an item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each item to its place.",
        "options": [
          { "id": "salt1", "text": "Salt", "image": "", "targetText": "Sahara", "targetImage": "" },
          { "id": "gold1", "text": "Gold", "image": "", "targetText": "West Africa", "targetImage": "" },
          { "id": "mali2", "text": "Mali", "image": "", "targetText": "Between them", "targetImage": "" }
        ]
      },
      {
        "question": "Grab or click an item from the top row (A) and drop it on the item from the bottom row (B) that matches. Finish the idea from the song.",
        "options": [
          { "id": "trade1", "text": "Salt was traded", "image": "", "targetText": "For gold", "targetImage": "" },
          { "id": "timbuktu2", "text": "Timbuktu", "image": "", "targetText": "In Mali", "targetImage": "" },
          { "id": "mali3", "text": "Mali was", "image": "", "targetText": "A great empire", "targetImage": "" }
        ]
      },
      {
        "question": "Grab or click an item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each term to its category.",
        "options": [
          { "id": "mali4", "text": "Mali", "image": "", "targetText": "Empire", "targetImage": "" },
          { "id": "timbuktu3", "text": "Timbuktu", "image": "", "targetText": "City", "targetImage": "" },
          { "id": "kings2", "text": "Kings", "image": "", "targetText": "Rulers", "targetImage": "" }
        ]
      },
      {
        "question": "Grab or click an item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each phrase to its detail.",
        "options": [
          { "id": "between1", "text": "In between", "image": "", "targetText": "Salt & gold", "targetImage": "" },
          { "id": "wealth1", "text": "Mali’s kings", "image": "", "targetText": "Were wealthy", "targetImage": "" },
          { "id": "center1", "text": "Mali was", "image": "", "targetText": "Trade hub", "targetImage": "" }
        ]
      }
    ]
  },
  


  // North American Features - Drag and Drop
 // North America Features - Multiple Choice
 {
  "slug": "north-america-features",
  "title": "North America Features",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Which river flows into the Gulf of Mexico?",
      "questionImage": "",
      "answers": [
        { "text": "Mississippi River", "correct": true, "image": "" },
        { "text": "Colorado River", "correct": false, "image": "" },
        { "text": "St. Lawrence River", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which river connects the Great Lakes to the Atlantic Ocean?",
      "questionImage": "",
      "answers": [
        { "text": "St. Lawrence River", "correct": true, "image": "" },
        { "text": "Missouri River", "correct": false, "image": "" },
        { "text": "Columbia River", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What kind of mountains are the Appalachian Mountains?",
      "questionImage": "",
      "answers": [
        { "text": "Rounded Mountains", "correct": true, "image": "" },
        { "text": "Pointed Mountains", "correct": false, "image": "" },
        { "text": "Volcanic Mountains", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which natural landmark was carved by the Colorado River?",
      "questionImage": "",
      "answers": [
        { "text": "Grand Canyon", "correct": true, "image": "" },
        { "text": "Great Salt Lake", "correct": false, "image": "" },
        { "text": "Niagara Falls", "correct": false, "image": "" }
      ]
    }
  ]
},


  // Africa Features - Multiple Choice
  {
    "slug": "africa-features",
    "title": "Africa Features",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is the longest river in the world that flows through Africa?",
        "questionImage": "",
        "answers": [
          { "text": "Nile River", "correct": true, "image": "" },
          { "text": "Congo River", "correct": false, "image": "" },
          { "text": "Amazon River", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Where are the Atlas Mountains located?",
        "questionImage": "",
        "answers": [
          { "text": "Northwest Africa", "correct": true, "image": "" },
          { "text": "East Africa", "correct": false, "image": "" },
          { "text": "Central Africa", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is the largest desert on Earth?",
        "questionImage": "",
        "answers": [
          { "text": "Sahara Desert", "correct": true, "image": "" },
          { "text": "Kalahari Desert", "correct": false, "image": "" },
          { "text": "Gobi Desert", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is the tallest mountain in Africa?",
        "questionImage": "",
        "answers": [
          { "text": "Mount Kilimanjaro", "correct": true, "image": "" },
          { "text": "Mount Kenya", "correct": false, "image": "" },
          { "text": "Mount Everest", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which river flows through the African rainforest?",
        "questionImage": "",
        "answers": [
          { "text": "Congo River", "correct": true, "image": "" },
          { "text": "Niger River", "correct": false, "image": "" },
          { "text": "Zambezi River", "correct": false, "image": "" }
        ]
      }
    ]
  },
  


  // Europe Features - Drag and Drop
 // Europe Features - Multiple Choice
 {
  "slug": "europe-features",
  "title": "Europe Features",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Which sea is important for trade in Europe?",
      "questionImage": "",
      "answers": [
        { "text": "Mediterranean Sea", "correct": true, "image": "" },
        { "text": "Baltic Sea", "correct": false, "image": "" },
        { "text": "North Sea", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What are the Alps?",
      "questionImage": "",
      "answers": [
        { "text": "Tall and wide mountains in Europe", "correct": true, "image": "" },
        { "text": "The longest river in Europe", "correct": false, "image": "" },
        { "text": "A desert in Europe", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which river is the longest in Europe?",
      "questionImage": "",
      "answers": [
        { "text": "Volga River", "correct": true, "image": "" },
        { "text": "Danube River", "correct": false, "image": "" },
        { "text": "Rhine River", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which river flows through many countries in Europe?",
      "questionImage": "",
      "answers": [
        { "text": "Danube River", "correct": true, "image": "" },
        { "text": "Volga River", "correct": false, "image": "" },
        { "text": "Thames River", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What kind of landform makes up most of Northern Europe?",
      "questionImage": "",
      "answers": [
        { "text": "Plains", "correct": true, "image": "" },
        { "text": "Deserts", "correct": false, "image": "" },
        { "text": "Canyons", "correct": false, "image": "" }
      ]
    }
  ]
},

  // South America Features - Multiple Choice
  {
    "slug": "south-america-features",
    "title": "South America Features",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Which is the second longest river in the world that flows through South America?",
        "questionImage": "",
        "answers": [
          { "text": "Amazon River", "correct": true, "image": "" },
          { "text": "Nile River", "correct": false, "image": "" },
          { "text": "Mississippi River", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What are the Andes Mountains known for?",
        "questionImage": "",
        "answers": [
          { "text": "Being the longest mountain range in the world", "correct": true, "image": "" },
          { "text": "Being the tallest mountain in the world", "correct": false, "image": "" },
          { "text": "Being a small group of hills", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is the largest rainforest in the world located in South America?",
        "questionImage": "",
        "answers": [
          { "text": "Amazon Rainforest", "correct": true, "image": "" },
          { "text": "Congo Rainforest", "correct": false, "image": "" },
          { "text": "Taiga Forest", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which desert in South America is one of the driest places on Earth?",
        "questionImage": "",
        "answers": [
          { "text": "Atacama Desert", "correct": true, "image": "" },
          { "text": "Sahara Desert", "correct": false, "image": "" },
          { "text": "Kalahari Desert", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which highland area is home to the Inca civilization’s famous site Machu Picchu?",
        "questionImage": "",
        "answers": [
          { "text": "Andes Mountains", "correct": true, "image": "" },
          { "text": "Rocky Mountains", "correct": false, "image": "" },
          { "text": "Himalayas", "correct": false, "image": "" }
        ]
      }
    ]
  },
  


  // Producer - Multiple Choice
  {
    "slug": "producer",
    "title": "Producer",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is a producer?",
        "questionImage": "",
        "answers": [
          { "text": "Someone who makes goods and provides services", "correct": true, "image": "" },
          { "text": "Someone who only buys goods", "correct": false, "image": "" },
          { "text": "Someone who stores goods", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is a consumer?",
        "questionImage": "",
        "answers": [
          { "text": "A person who buys and uses goods and services", "correct": true, "image": "" },
          { "text": "A person who produces goods", "correct": false, "image": "" },
          { "text": "A person who manages resources", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What does it mean when resources are scarce?",
        "questionImage": "",
        "answers": [
          { "text": "Resources are limited and not always available", "correct": true, "image": "" },
          { "text": "Resources are unlimited", "correct": false, "image": "" },
          { "text": "Resources are free for everyone", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Why do people have to make choices about what to buy?",
        "questionImage": "",
        "answers": [
          { "text": "Because resources and money are limited", "correct": true, "image": "" },
          { "text": "Because stores are closed", "correct": false, "image": "" },
          { "text": "Because everything is free", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What do producers and consumers depend on each other for?",
        "questionImage": "",
        "answers": [
          { "text": "Goods and services", "correct": true, "image": "" },
          { "text": "Games and prizes", "correct": false, "image": "" },
          { "text": "Books and toys", "correct": false, "image": "" }
        ]
      }
    ]
  },
  


  // Trade - Multiple Choice
  {
    "slug": "trade",
    "title": "Trade",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What does specialization mean for people and regions?",
        "questionImage": "",
        "answers": [
          { "text": "They focus on making certain goods and services", "correct": true, "image": "" },
          { "text": "They make all goods and services", "correct": false, "image": "" },
          { "text": "They only do farming", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Why do people and regions trade with others?",
        "questionImage": "",
        "answers": [
          { "text": "To get what they don’t have", "correct": true, "image": "" },
          { "text": "Because they have extra time", "correct": false, "image": "" },
          { "text": "To make new friends", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What do specialized regions provide to others in exchange?",
        "questionImage": "",
        "answers": [
          { "text": "Goods and services", "correct": true, "image": "" },
          { "text": "Nothing", "correct": false, "image": "" },
          { "text": "Only money", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What phrase in the song explains specialization?",
        "questionImage": "",
        "answers": [
          { "text": "Make and provide", "correct": true, "image": "" },
          { "text": "Hide and keep", "correct": false, "image": "" },
          { "text": "Spend and borrow", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What do people get through trade that they could not produce themselves?",
        "questionImage": "",
        "answers": [
          { "text": "Needed goods", "correct": true, "image": "" },
          { "text": "Extra chores", "correct": false, "image": "" },
          { "text": "More taxes", "correct": false, "image": "" }
        ]
      }
    ]
  },
  

  // Wants and Choices - Drag and Drop
  {
    "slug": "wantsandchoices",
    "title": "Wants and Choices",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop or tap it on the matching item in the bottom row (B). Match the term to its meaning.",
        "options": [
          { "id": "want1", "text": "Want", "image": "", "targetText": "Like to have", "targetImage": "" },
          { "id": "choice1", "text": "Choice", "image": "", "targetText": "Pick between", "targetImage": "" },
          { "id": "limit1", "text": "Limited", "image": "", "targetText": "Can’t have all", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop or tap it on the matching item in the bottom row (B). Match each example to Want or Choice.",
        "options": [
          { "id": "toy", "text": "New toy", "image": "", "targetText": "Want", "targetImage": "" },
          { "id": "icecream", "text": "Ice cream", "image": "", "targetText": "Want", "targetImage": "" },
          { "id": "pick", "text": "Pick one", "image": "", "targetText": "Choice", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop or tap it on the matching item in the bottom row (B). Match the phrase to the key word.",
        "options": [
          { "id": "twoormore", "text": "Two or more", "image": "", "targetText": "Choice", "targetImage": "" },
          { "id": "liketohave", "text": "Like to have", "image": "", "targetText": "Want", "targetImage": "" },
          { "id": "noteverything", "text": "Not everything", "image": "", "targetText": "Limited", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop or tap it on the matching item in the bottom row (B). Match the cause to its effect.",
        "options": [
          { "id": "limited2", "text": "Limited stuff", "image": "", "targetText": "Make choices", "targetImage": "" },
          { "id": "twothings", "text": "Two things", "image": "", "targetText": "Choose one", "targetImage": "" },
          { "id": "wantmore", "text": "Want more", "image": "", "targetText": "Can’t have all", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop or tap it on the matching item in the bottom row (B). Match each situation to the right label.",
        "options": [
          { "id": "bikeball", "text": "Bike or ball", "image": "", "targetText": "Choice", "targetImage": "" },
          { "id": "cake", "text": "Birthday cake", "image": "", "targetText": "Want", "targetImage": "" },
          { "id": "noall", "text": "Can’t buy all", "image": "", "targetText": "Limited", "targetImage": "" }
        ]
      }
    ]
  },
  

  
  // Responsible Citizen - Multiple Choice
  {
    "slug": "responsiblecitizen",
    "title": "Responsible Citizen",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What should responsible citizens do about laws?",
        "questionImage": "",
        "answers": [
          { "text": "Obey laws", "correct": true, "image": "" },
          { "text": "Break laws", "correct": false, "image": "" },
          { "text": "Ignore laws", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. When called for civic duty, what might a citizen serve on?",
        "questionImage": "",
        "answers": [
          { "text": "A jury", "correct": true, "image": "" },
          { "text": "A parade", "correct": false, "image": "" },
          { "text": "A concert", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is another duty of responsible citizens?",
        "questionImage": "",
        "answers": [
          { "text": "Pay taxes", "correct": true, "image": "" },
          { "text": "Skip taxes", "correct": false, "image": "" },
          { "text": "Hide taxes", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. When might responsible citizens serve in the armed forces?",
        "questionImage": "",
        "answers": [
          { "text": "If called", "correct": true, "image": "" },
          { "text": "Only on weekends", "correct": false, "image": "" },
          { "text": "Never", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What should each of us aim to be?",
        "questionImage": "",
        "answers": [
          { "text": "A responsible citizen", "correct": true, "image": "" },
          { "text": "A litter bug", "correct": false, "image": "" },
          { "text": "A rule breaker", "correct": false, "image": "" }
        ]
      }
    ]
  },
  

  // The Government - Multiple Choice
  {
    "slug": "thegovernment",
    "title": "The Government",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Why do governments make laws for everyone?",
        "questionImage": "",
        "answers": [
          { "text": "To protect people’s rights and property", "correct": true, "image": "" },
          { "text": "To sell products", "correct": false, "image": "" },
          { "text": "To make games", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is one reason laws are made?",
        "questionImage": "",
        "answers": [
          { "text": "To keep people safe", "correct": true, "image": "" },
          { "text": "To create noise", "correct": false, "image": "" },
          { "text": "To block travel", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which part of government puts laws into action?",
        "questionImage": "",
        "answers": [
          { "text": "The group that carries out laws", "correct": true, "image": "" },
          { "text": "The group that sings laws", "correct": false, "image": "" },
          { "text": "The group that hides laws", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which part of government decides whether laws have been broken?",
        "questionImage": "",
        "answers": [
          { "text": "The courts that decide in trials", "correct": true, "image": "" },
          { "text": "The people who paint signs", "correct": false, "image": "" },
          { "text": "The workers who build roads", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Besides safety, what is another purpose of laws?",
        "questionImage": "",
        "answers": [
          { "text": "To maintain order", "correct": true, "image": "" },
          { "text": "To make noise", "correct": false, "image": "" },
          { "text": "To raise prices", "correct": false, "image": "" }
        ]
      }
    ]
  },
  

  // As Americans - Multiple Choice
  {
    "slug": "asamericans",
    "title": "As Americans",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Which rights are repeated in the chorus as belonging to Americans?",
        "questionImage": "",
        "answers": [
          { "text": "Life, liberty, and happiness", "correct": true, "image": "" },
          { "text": "Only property", "correct": false, "image": "" },
          { "text": "Only travel", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Where do American people come from according to the verse?",
        "questionImage": "",
        "answers": [
          { "text": "Many countries", "correct": true, "image": "" },
          { "text": "One city", "correct": false, "image": "" },
          { "text": "One family", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What kind of government principle unites people as Americans?",
        "questionImage": "",
        "answers": [
          { "text": "A republican form of government", "correct": true, "image": "" },
          { "text": "Absolute rule", "correct": false, "image": "" },
          { "text": "No laws", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What idea shows that Americans have different backgrounds?",
        "questionImage": "",
        "answers": [
          { "text": "Different ethnic origins", "correct": true, "image": "" },
          { "text": "Same hobbies", "correct": false, "image": "" },
          { "text": "Same food", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What do these government principles help Americans do together?",
        "questionImage": "",
        "answers": [
          { "text": "Unite as one nation", "correct": true, "image": "" },
          { "text": "Divide from each other", "correct": false, "image": "" },
          { "text": "Separate by regions", "correct": false, "image": "" }
        ]
      }
    ]
  }
  
  

]

export default va3rdSocialStudiesQuizContent;
